const ACTION_TYPES = {
    SHOW_ERROR: 'SHOW_KLARNA_ERROR',
    TOGGLE_SHIPPING: 'TOGGLE_SHIPPING',
    TOGGLE_SELECTED: 'TOGGLE_SELECTED',
    OBSERVE_MODAL: 'OBSERVE_MODAL'
};

const initialState = {
    isReady: false,
    isSelected: false,
    useMyShippingAddress: false,
    error: null,
    isActive: false
};

const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.TOGGLE_SELECTED:
            return Object.assign({}, state, {
                isSelected: action.isSelected,
                isReady: false
            });
        case ACTION_TYPES.SHOW_ERROR:
            return Object.assign({}, state, {
                error: action.error,
                isSelected: false,
                isReady: false
            });
        case ACTION_TYPES.TOGGLE_SHIPPING:
            return Object.assign({}, state, {
                useMyShippingAddress: action.useMyShippingAddress
            });
        case ACTION_TYPES.OBSERVE_MODAL:
            return Object.assign({}, state, {
                isActive: action.isActive
            });
        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
